export const YOUNGEST_AGE_ON_PLATFORM = 13;

export const GENDER = Object.freeze({
  man: 'man',
  woman: 'woman',
  preferNotSay: 'prefer_not_say',
  nonBinary: 'nonbinary'
});

export default { YOUNGEST_AGE_ON_PLATFORM, GENDER };
